import React from 'react';
import Section from 'views/services/Section';
import SectionContents from 'views/services/SectionContents';
import SectionContentsBody from 'views/services/SectionContentsBody';
import CertifiedOnceAssets from './CertifiedOnceAssets';

import styles from './styles.module.scss';
import CertifiedOnceContents from './CertifiedOnceContents';

function Index() {
  return (
    <Section light>
      <SectionContents sizes={{xs: [12, 12], lg: [6, 6]}}>
        <CertifiedOnceAssets />
        <div className={styles['certified-body']}>
          <div className={styles['certified-body--contents']}>
            <SectionContentsBody title="Certified Once, Accepted Everywhere" />
            <p>
              By <span>cross-checking all three data sources</span>, IAF
              CertSearch can state with 100% confidence that:
            </p>
            <CertifiedOnceContents />
          </div>
          <p>
            We receive data dynamically from over{' '}
            <span>2,500 certification and accreditation bodies worldwide</span>,
            via API or automated file transfer.
          </p>
        </div>
      </SectionContents>
    </Section>
  );
}

export default Index;
